import React, { useEffect, useRef, useState } from 'react';
import { lang, setLanguage } from './index';
import './LanguageSwitcher.css';

// Languages shown in the list. To add one later: add it here AND add its
// dictionary to DICTIONARIES in ./index.js.
const LANGUAGES = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'ar', label: 'العربية', short: 'ع' },
];

// Footer language list: a button with the current language; clicking it
// opens a small list ABOVE the button (the footer is at the bottom).
export default function LanguageSwitcher() {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  // Close on a click outside or on Escape.
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="lang-menu" ref={boxRef}>
      <button
        type="button"
        className="lang-menu__button"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        title="Language / اللغة"
      >
        <i className="fas fa-globe" aria-hidden="true" />
        <span>{current.label}</span>
        <i className={`fas fa-chevron-${open ? 'down' : 'up'} lang-menu__chevron`} aria-hidden="true" />
      </button>

      {open && (
        <ul className="lang-menu__list" role="listbox" aria-label="Language / اللغة">
          {LANGUAGES.map((l) => (
            <li key={l.code} role="option" aria-selected={l.code === lang}>
              <button
                type="button"
                className={`lang-menu__item${l.code === lang ? ' is-active' : ''}`}
                lang={l.code}
                onClick={() => {
                  setOpen(false);
                  setLanguage(l.code); // reloads the page when the language changes
                }}
              >
                <span className="lang-menu__short">{l.short}</span>
                <span className="lang-menu__label">{l.label}</span>
                {l.code === lang && <i className="fas fa-check" aria-hidden="true" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
